import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";

import { Location } from "@angular/common";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  Event as NgEvent,
} from "@angular/router";
import { Title } from "@angular/platform-browser";
import { NavigationItem } from "./navigation/navigation";
import { AdminSnackbarComponent } from "./notifications/admin-snackbar/admin-snackbar.component";
import { LoadDataService } from "./cache/load-data/load-data.service";
import { ToastyService } from "ng2-toasty";
import { DattaConfig } from "../config/app-config";
import { SnackBarService } from "../services/snack-bar/snack-bar.service";
import { LocalizationHandlerService } from "../services/admin/localization/localization-handler.service";
import { StyleHandlerService } from "../services/admin/style-handler.service";

@Component({
  selector: "app-admin",
  templateUrl: "./admin.component.html",
  styleUrls: ["./admin.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AdminComponent implements OnInit, AfterViewInit, OnDestroy {
  __DattaConfig: any;
  __NavCollapsed: boolean;
  __NavCollapsedMob: boolean;
  _WindowWidth: number;
  __IsLoading: boolean;
  _IdleTimeout;
  __IsDoorsResolved = false;
  _HasLoadedDoors = false;

  @ViewChild("snackbar", { static: false, read: AdminSnackbarComponent })
  _SnackbarRef: AdminSnackbarComponent;

  constructor(
    private _Location: Location,
    private _Router: Router,
    private _TitleService: Title,
    public _SnackbarService: SnackBarService,
    private _LocaleHandlerService: LocalizationHandlerService,
    private _LoadDataService: LoadDataService,
    private _ToastyService: ToastyService,
    private _StyleHandlerService: StyleHandlerService
  ) {
    this.__IsLoading = true;

    this._Router.events.subscribe((routerEvent: NgEvent) => {
      if (routerEvent instanceof NavigationStart) {
        this.__IsLoading = true;
      }

      if (
        routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationError ||
        routerEvent instanceof NavigationCancel
      ) {
        let title = this.CheckNavTitle(routerEvent.url);
        if (typeof title === "string") {
          this._TitleService.setTitle(title);
        } else {
          (title as any)?.subscribe((val) => {
            this._TitleService.setTitle(val + " | IntegrA Cloud");
          });
        }

        this.__IsLoading = false;
      }
    });

    this.__DattaConfig = DattaConfig.config;

    let current_url = this._Location.path();
    if (this._Location["_baseHref"]) {
      current_url = this._Location["_baseHref"] + this._Location.path();
    }

    if (
      current_url === this._Location["_baseHref"] + "/layout/collapse-menu" ||
      current_url === this._Location["_baseHref"] + "/layout/box"
    ) {
      this.__DattaConfig["collapse-menu"] = true;
    }

    this._WindowWidth = window.innerWidth;
    this.__NavCollapsed =
      this._WindowWidth >= 992 ? this.__DattaConfig["collapse-menu"] : false;
    this.__NavCollapsedMob = false;
  }

  ngOnInit() {
    this._StyleHandlerService.adminNotificationEmitter.subscribe((value) => {
      this.ShowNotification(value.toastOptions, value.type);
    });

    this._SnackbarService.snackBarEvent.subscribe((data) => {
      data.snackbarRef = this._SnackbarRef;
      this._SnackbarService.eventHandler(data);
    });

    let expiresIn = sessionStorage.getItem("expires");
    if (sessionStorage.getItem("token") == null || expiresIn == null) {
      this._Router.navigate(["/auth/signin"]);
    }

    if (new Date(expiresIn).getTime() < Date.now()) {
      this._Router.navigate(["/auth/signin"]);
    }

    if (this._LoadDataService.cachedDoors == undefined) {
      sessionStorage.setItem(
        "lastRoute",
        this._Router.routerState.snapshot.url
      );
      this._Router.navigate(["/loading-data"]).then((val) => {
        setTimeout(() => {
          this.__IsDoorsResolved = true;
        }, 100);
      });
    }
  }

  ngAfterViewInit() {
    document.querySelector("body").classList.remove("isSkyAccess");
    this.HandleIdleTimeout();
  }

  ngOnDestroy(): void {
    clearTimeout(this._IdleTimeout);
  }

  __OnNavCollapseSwiperFix() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1000);
  }

  __NavMobClick() {
    setTimeout(() => {
      const element = document.querySelector(
        "app-navigation.pcoded-navbar"
      ) as HTMLElement;
      const isOpen = document
        .querySelector("app-navigation.pcoded-navbar")
        .classList.contains("mob-open");

      if (isOpen) {
        element.classList.remove("mob-open");
        this.__NavCollapsedMob = !isOpen;
      } else {
        element.classList.add("mob-open");
        this.__NavCollapsedMob = !isOpen;
      }
    }, 100);
  }

  CheckNavTitle(currentRoute: string) {
    let currentTitle: any = "IntegrA | Cloud";

    currentRoute = currentRoute?.toLowerCase();
    let navItems = new NavigationItem().get()[0].children;

    navItems.forEach((navItem) => {
      let containsChildTopLevel =
        navItem.children != undefined && navItem.children?.length > 0;
      if (!containsChildTopLevel) return "IntegrA | Cloud";
      navItem.children.forEach((elementSubMenu) => {
        let containsChild =
          (elementSubMenu as any).children != undefined &&
          (elementSubMenu as any).children?.length > 0;

        let itemRoute = (elementSubMenu.url as string)?.toLowerCase();

        if (itemRoute == currentRoute) {
          currentTitle = this._LocaleHandlerService.getTranslation(
            "nav." + elementSubMenu.title
          );
        }

        if (containsChild) {
          (elementSubMenu as any).children.forEach((element) => {
            let itemRouteChild = (element.url as string)?.toLowerCase();

            if (itemRouteChild == currentRoute) {
              currentTitle = this._LocaleHandlerService.getTranslation(
                "nav." + elementSubMenu.title
              );
            }
          });
        }
      });
    });

    return currentTitle;
  }

  // @HostListener('click', ['$event'])
  ApplyCursorRippleEffect(e) {
    const ripple = document.createElement("div");

    ripple.className = "ripple";
    document.body.appendChild(ripple);

    ripple.style.left = `${e.clientX}px`;
    ripple.style.top = `${e.clientY}px`;
    ripple.style.animation = `ripple-effect .4s  linear`;
    ripple.onanimationend = () => {
      document.body.removeChild(ripple);
    };
  }

  ClickRippleEffect() {
    const all = document.body.getElementsByTagName("*");
    for (var i = 0; i < all.length; ++i) {
      (all[i] as HTMLElement).onclick = (event) => event.stopPropagation();
    }
  }

  HandleIdleTimeout() {
    const idleDurationSecs = 3600;
    const redirectUrl = "/auth/signin";
    // let idleTimeout;

    const resetIdleTimeout = () => {
      if (this._IdleTimeout) clearTimeout(this._IdleTimeout);

      this._IdleTimeout = setTimeout(() => {
        sessionStorage.setItem("LogOutReason", "2");
        sessionStorage.token = undefined;
        location.href = redirectUrl;
      }, idleDurationSecs * 1000);
    };

    // Key events for reset time
    resetIdleTimeout();
    window.onmousemove = resetIdleTimeout;
    window.onkeypress = resetIdleTimeout;
    window.onclick = resetIdleTimeout;
    window.ontouchstart = resetIdleTimeout;
    window.onfocus = resetIdleTimeout;
    window.onchange = resetIdleTimeout;
    window.onmouseover = resetIdleTimeout;
    window.onmouseout = resetIdleTimeout;
    window.onmousemove = resetIdleTimeout;
    window.onmousedown = resetIdleTimeout;
    window.onmouseup = resetIdleTimeout;
    window.onkeypress = resetIdleTimeout;
    window.onkeydown = resetIdleTimeout;
    window.onkeyup = resetIdleTimeout;
    window.onsubmit = resetIdleTimeout;
    window.onreset = resetIdleTimeout;
    window.onselect = resetIdleTimeout;
    window.onscroll = resetIdleTimeout;
  }

  ShowNotification(toastOptions, type: number) {
    if (
      !this._Router.routerState.snapshot.url
        .toLowerCase()
        .includes("monitoring/door-monitoring")
    ) {
      this._ToastyService.clearAll();
      return;
    }

    switch (type) {
      case 0:
        this._ToastyService.default(toastOptions);
        break;
      case 1:
        this._ToastyService.info(toastOptions);
        break;
      case 2:
        this._ToastyService.success(toastOptions);
        break;
      case 3:
        this._ToastyService.wait(toastOptions);
        break;
      case 4:
        this._ToastyService.warning(toastOptions);
        break;
      case 5:
        this._ToastyService.error(toastOptions);
        break;
    }
  }
}
